(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vuneyo-vacuum"] && !Shopify.designMode) return;
  try {
    
function bindVuneyoGalleries(){document.querySelectorAll('.vv').forEach(section=>{const gallery=section.querySelector('.vv-gallery');if(!gallery||gallery.dataset.bound)return;gallery.dataset.bound='true';const main=gallery.querySelector('.vv-image img');const thumbs=gallery.querySelectorAll('.vv-thumb');function showImage(url){if(!main||!url)return;main.src=url;main.removeAttribute('srcset');thumbs.forEach(other=>other.setAttribute('aria-pressed',String(other.dataset.image===url)));}thumbs.forEach(button=>button.addEventListener('click',()=>showImage(button.dataset.image)));section.querySelectorAll('.vv-options input[name="id"]').forEach(input=>input.addEventListener('change',()=>{if(input.checked){showImage(input.dataset.image);const status=section.querySelector('.vv-shipping-status');if(status)status.textContent=status.dataset.freeCountry==='true'&&input.value===status.dataset.vacuumId?status.dataset.freeLabel:status.dataset.paidLabel;}}));});}
bindVuneyoGalleries();document.addEventListener('shopify:section:load',bindVuneyoGalleries);

  } catch(e) { console.error(e); }
})();
})();
